import {
  GET_RESERVATIONLIST,
  GET_ADDRESERVATION,
  GET_UPDATERESERVATION,
  GET_RESERVATIONDETAILS,
  GET_BOOKINGREPORTDOWNLOAD,
  GET_CANCELCHARGES,
  GET_CANCELREASON,
  GET_BOOKINGBUFFERTIME,
  GET_AIRPORTTERMINALLIST
} from "resources/actionTypes";

export function getReservationList(reservationData) {
  return {
    type: GET_RESERVATIONLIST.GET_RESERVATIONLIST_REQUESTED,
    payload: reservationData,
  };
}

export function getReservationDetails(reservationPayload) {
  return {
    type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED,
    payload: reservationPayload,
  };
}

export function clearReservationDetails() {
  return {
    type: GET_RESERVATIONDETAILS.CLEAR_RESERVATIONDETAILS,
  };
}

export function postAddReservation(reservationData, toggle) {
  const data = {
    reservationData: reservationData,
    setConfirmModal: toggle,
  };
  return {
    type: GET_ADDRESERVATION.GET_ADDRESERVATION_REQUESTED,
    payload: data,
  };
}

export function patchupdateReservation(updateReservationData, pageType, id) {
  const data = {
    updateReservationData: updateReservationData,
    navigate: pageType,
    id: id
  };

  return {
    type: GET_UPDATERESERVATION.GET_UPDATERESERVATION_REQUESTED,
    payload: data,
  };
}


// Download Report
export function getDownLoadList(downloadData) {
  return {
    type: GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_REQUESTED,
    payload: downloadData,
  };
}

export function getCancelReason(cancelReasonData) {
  return {
    type: GET_CANCELREASON.GET_CANCELREASON_REQUESTED,
    payload: cancelReasonData,
  };
}

export function getBookingBufferTime(payloadData) {
  return {
    type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED,
    payload: payloadData
  }
}

export function getAirportTerminalList(payloadData) {
  return {
    type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED,
    payload: payloadData
  }
}